/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-no-constructed-context-values */
import React from 'react';
import { LLMModel, getDeploymentName } from '../Components/Contexts/LLMSettingContext';
import { mockUserPrompt, evaluatorPrompt } from './const';

export type TestSetting = {
  // mockUser settings
  mockUserMaxTokens: number,
  mockUserTemperature: number,
  mockUserModel: LLMModel,
  mockUserDeployment: string,
  mockUserPrompt: string,
  mockUserIgnoreDefaultFewShotExamples: boolean,

  // evaluator settings
  evaluatorMaxTokens: number,
  evaluatorTemperature: number,
  evaluatorModel: LLMModel,
  evaluatorPrompt: string,
  evaluatorIgnoreDefaultFewShotExamples: boolean,
};

export type TestSettingContextType = {
  updateTestSetting: (setting: TestSetting) => void,
} & TestSetting;

export const defaultTestSettings: TestSetting = {
  // mockUser settings
  mockUserMaxTokens: 512,
  mockUserTemperature: 0.4,
  mockUserModel: LLMModel.Gpt35Turbo,
  mockUserDeployment: getDeploymentName(LLMModel.Gpt35Turbo),
  mockUserPrompt,
  mockUserIgnoreDefaultFewShotExamples: true,

  // evaluator settings
  evaluatorMaxTokens: 512,
  evaluatorTemperature: 0.4,
  evaluatorModel: LLMModel.Gpt35Turbo,
  evaluatorPrompt,
  evaluatorIgnoreDefaultFewShotExamples: true,
};

const TestSettingContext = React.createContext<TestSettingContextType>({
  ...defaultTestSettings,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateTestSetting: (setting: TestSetting) => { },
});

export const useTestSetting = (): TestSettingContextType => React.useContext(TestSettingContext);

export const TestSettingProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [testSetting, setTestSetting] = React.useState<TestSetting>(defaultTestSettings);

  const updateTestSetting = React.useCallback((newTestSettings: TestSetting) => {
    setTestSetting(newTestSettings);
  }, [setTestSetting]);

  return (
    <TestSettingContext.Provider value={{
      ...testSetting,
      updateTestSetting,
    }}
    >
      {children}
    </TestSettingContext.Provider>
  );
};
